import React, { useState, useEffect } from 'react';
import { AuthProvider } from 'react-oidc-context';
import { UserManagerSettings } from 'oidc-client-ts';
import { getOidcConfig } from '../oidc-config-dynamic';

interface DynamicAuthProviderProps {
    children: React.ReactNode;
}

export default function DynamicAuthProvider({ children }: DynamicAuthProviderProps) {
    const [oidcConfig, setOidcConfig] = useState<UserManagerSettings | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const loadConfig = async () => {
            try {
                const config = await getOidcConfig();
                setOidcConfig(config);
                setError(null);
            } catch (err) {
                console.error('Failed to load OIDC configuration:', err);
                setError(err instanceof Error ? err.message : 'Unknown error');
            } finally {
                setLoading(false);
            }
        };

        loadConfig();
    }, []);

    if (loading) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                fontSize: '18px'
            }}>
                Loading authentication configuration...
            </div>
        );
    }

    if (error || !oidcConfig) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column',
                fontSize: '18px'
            }}>
                <div style={{ color: 'red', marginBottom: '20px' }}>
                    Failed to load authentication configuration
                </div>
                <div style={{ fontSize: '14px', color: '#666' }}>
                    {error || 'Configuration not available'}
                </div>
            </div>
        );
    }

    return (
        <AuthProvider {...oidcConfig}>
            {children}
        </AuthProvider>
    );
}
